import { combineReducers } from '@reduxjs/toolkit';

import { authReducer, AuthState } from './slices/auth';
import { callbackTriggersReducer, CallbackTriggersState } from './slices/callbackTriggers';
import { channelsReducer, ChannelsState } from './slices/channels';
import { eventsReducer, EventsSlice } from './slices/events';
import { loaderReducer, LoaderState } from './slices/loader';
import { profileReducer, ProfileState } from './slices/profile';
import { sessionReducer, SessionState } from './slices/session';
import { streamingPlatformsReducer, StreamingPlatformsState } from './slices/streamingPlatforms';

export type RootState = {
  auth: AuthState;
  loader: LoaderState;
  events: EventsSlice;
  streamingPlatforms: StreamingPlatformsState;
  profile: ProfileState;
  channels: ChannelsState;
  session: SessionState;
  callbackTriggers: CallbackTriggersState;
};

export const rootReducer = combineReducers<RootState>({
  auth: authReducer,
  loader: loaderReducer,
  events: eventsReducer,
  streamingPlatforms: streamingPlatformsReducer,
  profile: profileReducer,
  channels: channelsReducer,
  session: sessionReducer,
  callbackTriggers: callbackTriggersReducer
});
